$(document).ready(function () {
  if($('.recrutement').length > 0) {
    $( ".form-file-fr" ).each(function() {
      $(this).on("change", function(){
        $(this).parent().next(".form-filelabel").html($(this).prop('files')[0].name);
      });
    });
    $( ".form-file-en" ).each(function() {
      $(this).on("change", function(){
        $(this).parent().next(".form-filelabel").html($(this).prop('files')[0].name);
      });
    });
  }
});
